module.exports = __webpack_public_path__ + "img/EDT_LOGO.f8195e92.png";